<template>
  <layout-admin-dashboard-view :show-title-back-link="false">
    <template #title>
      {{ translateTitleCase("admin.dashboard.dashboardTitle") }}
    </template>

    <template #mainContent>
      <card title="admin.dashboard.tasks">
        <user-task-list></user-task-list>
      </card>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import UserTaskList from '@/client/views/admin/userTask/List.vue'

export default {
  name: "AdminDashboardViewLegacy",
  components: {UserTaskList},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "admin.dashboard.title",
  data: function () {
    return {
      links: [
        {
          to: { name: "admin-vendor" },
          icon: "cart",
          shortLabel: "admin.vendors.shortLabel",
          label: "admin.vendors.label",
          description: "admin.vendors.description",
        },
        {
          to: { name: "admin-entity" },
          icon: "copy",
          shortLabel: "admin.entity.titleShort",
          label: "admin.entity.title",
          description: "admin.entity.description",
        },

        {
          to: { name: "admin-user" },
          icon: "user",
          shortLabel: "admin.user.titleShort",
          label: "admin.user.title",
          description: "admin.user.description",
        },
        {
          to: { name: "admin-language" },
          icon: "chat",
          shortLabel: "admin.language.titleShort",
          label: "admin.language.title",
          description: "admin.language.description",
        },
      ],
    };
  },
  created() {

  },
};
</script>

<style scoped lang="scss">
.admin-item-link {
  cursor: pointer;

  .uk-card-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .uk-icon {
      position: relative;
      margin-right: 4px;
      // top: 0px;
    }
  }
}
</style>
